<template>
  <div :style="productContainerPanelStyle" class="transition-height w-100 mb-3">
    <div style="transition: all 1s" class="m-0 pb-4">
      <div v-if="theme.page_product_container_category_title_visible" class="col-12 p-0 mb-3 mt-1 ml-3 d-flex align-items-center">
        <h6 class="m-0" :style="{ color: theme && theme.page_toolbar_text_color ? theme.page_toolbar_text_color : '#ccc' }">
          <span class="font-weight-normal">Category:</span>
          {{ category }}({{ viewableProducts.length }})
        </h6>
      </div>

      <div v-if="getPage(viewableProducts, currentPage, perPage.value)" class="product-grid">
        <ProductGridPanel
          v-for="product in getPage(viewableProducts, currentPage, perPage.value)"
          :key="product.id"
          :product="product"
          :company="company"
          :user="user"
          :buyer="buyer"
          :cart-items="cartItems"
          :hide-prices="hidePrices"
          :hide-quantity="hideQuantity"
          :hide-shopping-actions="hideShoppingActions"
          :active-location="activeLocation"
          :theme="theme"
          :is-the-seller="isTheSeller"
          :bulk-discounts="bulkDiscounts"
          :use-cannabis-spinner="useCannabisSpinner"
          :chat-enabled="chatEnabled"
          @contact-button-clicked="$emit('contactButtonClicked')"
          @add-to-cart="(item) => $emit('add-to-cart', item)"
        />
        <!-- </div> -->
      </div>
      <div v-else-if="viewableProducts.length == 0 && filtered" class="border bg-light w-75 p-3 mx-auto my-5 rounded shadow-sm">
        <h6 class="m-0">Sorry we could not find any products that matched your search.</h6>
      </div>
      <div v-else-if="viewableProducts.length == 0 && !filtered" class="border bg-light w-75 p-3 mx-auto my-5 rounded shadow-sm">
        <h6 class="m-0">This vendor is currently sold out.</h6>
      </div>

      <div class="col-12 p-0 row m-0 align-items-center mt-3">
        <div v-if="!hideBranding" class="border py-3 px-4 bg-white rounded">
          <img
            :src="industry == 'cannabis' ? '/img/icons/logo-apex-powered.svg' : '/img/icons/logo-bushel-powered.svg'"
            alt="Store Cart"
            height="50px"
            width="150px"
            style=""
          />
        </div>
        <div class="row m-0 align-items-center ml-auto">
          <label class="m-0 p-0 mr-2">Show Per Page</label>
          <BushelSelect
            style="width: 130px"
            class="p-0 m-0"
            :options="perPageOptions"
            :allow-empty="false"
            :value="perPage"
            no-deselect
            label-class="d-none"
            :hide-selected="true"
            no-padding
            select-style="width: 100%;"
            :show-select-labels="false"
            placeholder="Per Page"
            track-by="id"
            label="value"
            @select="(v) => (perPage = v)"
          />
        </div>
        <b-pagination
          v-if="viewableProducts.length > perPage.value && perPage.value !== 'All'"
          class="justify-content-end m-0 ml-4 mr-3"
          :value="currentPage"
          :total-rows="viewableProducts.length"
          :per-page="perPage.value"
          aria-controls="my-table"
          @change="switchPage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BPagination from "@/components/base/BPagination.vue";
import { ColorLuminance } from "@/services/helpers";
import ProductGridPanel from "@/components/storefront/ProductGridPanel.vue";

export default {
  name: "StoreGrid",
  components: {
    ProductGridPanel,
    BPagination,
  },
  props: {
    company: { type: Object, required: true },
    user: { type: Object, default: null },
    buyer: { type: Object, default: null },
    products: { type: Array, required: true },
    theme: { type: Object, required: true },
    loggedIn: { type: Boolean, required: true },
    category: { type: String, required: true },
    cartItems: { type: Array },
    sidebarVisible: { type: Boolean, default: false },
    hidePrices: { type: Boolean },
    hideQuantity: { type: Boolean, default: false },
    hideShoppingActions: { type: Boolean, required: true },
    currentPage: { type: Number, default: 1 },
    filtered: { type: Boolean, default: false },
    useCannabisSpinner: { type: Boolean, default: true },
    bulkDiscounts: { type: Array, required: true },
    chatEnabled: { type: Boolean, default: false },
    isTheSeller: { type: Boolean, required: true },
    activeLocation: { type: Object },
    hideBranding: { type: Boolean, default: false },
  },
  emits: ["contactButtonClicked", "add-to-cart", "switch-page", "theme-switch"],
  data() {
    return {
      quantity: null,
      perPage: { id: 1, value: 24 },
      perPageOptions: [
        { id: 1, value: 12 },
        { id: 2, value: 24 },
        { id: 3, value: 36 },
        { id: 4, value: 48 },
        { id: 5, value: "All" },
      ],
      showSidebar: true,
      appName: APP_NAME,
      industry: APP_INDUSTRY,
    };
  },
  computed: {
    viewableProducts() {
      return this.products.filter((product) => product.batches.some((batch) => !batch.hold));
    },
    productContainerPanelStyle() {
      const bgStyle = {
        backgroundColor: this.theme.page_product_container_background_color,
        border: `${this.theme.page_product_container_border_color} 1px solid`,
        borderRadius: this.theme.page_product_container_rounded_corners_visible ? "0.25rem" : "0px",
        padding: `
                    ${`${this.theme.page_product_container_padding}rem`}`,
        "--page-bg-color": this.theme.page_button_color,
        boxShadow: this.theme.page_product_container_box_shadow_visible ? "0 0.5rem 1rem rgba(0, 0, 0, 0.05)" : null,
      };

      if (this.theme.page_product_container_background_image) {
        bgStyle.backgroundImage = `url(${this.theme.page_product_container_background_image})`;
        bgStyle.backgroundSize = "cover";
        bgStyle.backgroundPosition = "center";
      }

      return bgStyle;
    },
  },
  methods: {
    switchTheme() {
      this.$emit("theme-switch", "Data-Table");
    },
    switchPage(page) {
      this.$emit("switch-page", page);
    },
    ColorLuminance,
    productsByCategory(categoryId) {
      return this.viewableProducts.filter((product) => product.category_id == categoryId);
    },

    getPage(viewableProducts, page, perPage) {
      const currentPage = !page ? 1 : page;

      if (perPage !== "All") {
        const items = [];
        for (let i = 0; i < viewableProducts.length; i += perPage) {
          items.push(viewableProducts.slice(i, i + perPage));
        }
        return items[currentPage - 1];
      }
      return viewableProducts;
    },

    numberOfPages(perPage) {
      return Math.ceil(this.viewableProducts.length / perPage);
    },
  },
};
</script>

<style scoped>
.content-center {
  justify-content: space-around;
}

:deep(.customBushelSelectInput) {
  padding: 0.35rem 0.5rem;
  font-size: 13px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
